import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Mail, Phone, DollarSign, GripVertical } from "lucide-react";
import { cn } from "@/lib/utils";

const industryColors = {
  technology: "bg-lime-100 text-zinc-900",
  healthcare: "bg-red-100 text-red-700",
  finance: "bg-emerald-100 text-emerald-700",
  retail: "bg-orange-100 text-orange-700",
  manufacturing: "bg-slate-100 text-slate-700",
  real_estate: "bg-amber-100 text-amber-700",
  education: "bg-blue-100 text-blue-700",
  consulting: "bg-lime-100 text-zinc-900",
  other: "bg-gray-100 text-gray-700",
};

export default function PipelineCard({ customer, onClick }) {
  return (
    <Card 
      className="p-4 bg-white border border-slate-200 hover:shadow-md transition-all duration-200 cursor-pointer group mb-3"
      onClick={onClick}
    >
      <div className="flex items-start gap-2">
        <div className="mt-1 text-slate-300 group-hover:text-slate-400 transition-colors cursor-grab active:cursor-grabbing">
          <GripVertical className="w-4 h-4" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="font-semibold text-slate-900 text-sm mb-1 truncate group-hover:text-zinc-900 transition-colors">
            {customer.company_name}
          </h3>
          <p className="text-xs text-slate-500 mb-2 truncate">{customer.contact_name}</p>
          
          <div className="space-y-1.5 mb-3">
            {customer.contact_email && (
              <div className="flex items-center gap-1.5 text-xs text-slate-500">
                <Mail className="w-3 h-3 shrink-0" />
                <span className="truncate">{customer.contact_email}</span>
              </div>
            )}
            {customer.contact_phone && (
              <div className="flex items-center gap-1.5 text-xs text-slate-500">
                <Phone className="w-3 h-3 shrink-0" />
                <span className="truncate">{customer.contact_phone}</span>
              </div>
            )}
          </div>
          
          <div className="flex items-center justify-between">
            {customer.industry && (
              <Badge variant="secondary" className={cn("text-xs border-0", industryColors[customer.industry])}>
                {customer.industry?.replace("_", " ")}
              </Badge>
            )}
            {customer.deal_value > 0 && (
              <span className="text-xs font-semibold text-slate-900">
                {customer.deal_value.toLocaleString()} kr
              </span>
            )}
          </div>
        </div>
      </div>
    </Card>
  );
}